// export  const POINT = {
//   'POINT_OPEN_APP':'每日打开小译APP',
//   'POINT_READ_20_MIN':'每阅读20分钟',
//   'POINT_EXCHANGE':'积分兑换',
//   'POINT_READ_PAGE':'阅读一篇网页',
//   'POINT_LIKE_SENTENCE':'点赞1次',
//   'POINT_ADD_SENTENCE':'编译译文1次',
//   'POINT_SHARE_PAGE':'分享1次',
//   'POINT_OPEN_APP_7':'连续7天打开APP',
//   'POINT_HAVE_LIKED_SENTENCE':'编译译文被赞1次',
//   'POINT_BEST_SENTENCE':'编译译文被评为最佳译文'
// }


import { whatLang } from '@/utils/index'

const point = {
  'zh':{
    'POINT_READ_PAGE':'阅读一篇网页',
    'POINT_OPEN_APP':'每日打开小译APP',
    'POINT_OPEN_APP_7':'连续7天打开APP',
    'POINT_ADD_SENTENCE':'提交译文一次',
    'POINT_LIKE_SENTENCE':'点赞/踩',
    'POINT_HAVE_LIKED_SENTENCE':'提交的译文被赞一次',
    'POINT_BEST_SENTENCE':'提交的译文被评为最佳译文',
    'POINT_SHARE_PAGE':'分享一次',
    'POINT_READ_20_MIN':'每阅读20分钟',
    'POINT_EXCHANGE':'积分兑换',
  },
  'en':{
    'POINT_READ_PAGE':'Read a website',
    'POINT_OPEN_APP':'Use LingoCloud every day',
    'POINT_OPEN_APP_7':'Use LingoCloud continuously for 7 days',
    'POINT_ADD_SENTENCE':'Submit a translation once',
    'POINT_LIKE_SENTENCE':'Like/Click on a translation',
    'POINT_HAVE_LIKED_SENTENCE':'Edited translations be liked',
    'POINT_BEST_SENTENCE':'Edited translation chosen as the best text',
    'POINT_EXCHANGE':'Cloud Points Exchange',
    'POINT_READ_20_MIN':'Continuous reading for 20 minutes',
    'POINT_SHARE_PAGE':'Share page',
  }
}
let isLang = ''
if (whatLang() === 'zh') {
  isLang = 'zh'
} else {
  isLang = 'en'
}

export  const POINT = point[isLang]
export  const POINT_ICON = {
  'POINT_OPEN_APP':'+50',
  'POINT_READ_20_MIN':'+5',
  'POINT_READ_PAGE':'-30',
  'POINT_LIKE_SENTENCE':'+5',
  'POINT_ADD_SENTENCE':'+30',
  'POINT_SHARE_PAGE':'+20',
  'POINT_OPEN_APP_7':'+500',
  'POINT_HAVE_LIKED_SENTENCE':'+5',
  'POINT_BEST_SENTENCE':'+50'
}



// WEBPACK FOOTER //
// ./src/config/point-change.js